export const woltdelivery = {
  oAuthFlowHelp: "Mein Wolt Restaurant verbinden",
  authSuccess: "Authentifizierung erfolgreich",
  helpText:
    "Mit Wolt authentifizieren – Weiterleitung zu Wolt, nach erfolgreicher Anmeldung geht es zurück zu Xentral."
};
